import { getLocalData, StorageKeyOptionsEnum } from 'common/utils';
import { Dispatch, SetStateAction, useCallback, useRef, useState } from 'react';
import { apiUrlOptions } from 'src/api.config';
import { useOrganization } from 'src/pages/organization';

function buildAuthHeader(): string {
  const accessData = getLocalData(StorageKeyOptionsEnum.AccessData);
  const tokenType = accessData?.token_type ?? 'bearer';
  const capitalizedType =
    tokenType.charAt(0).toUpperCase() + tokenType.slice(1);
  return `${capitalizedType} ${accessData?.access_token ?? ''}`;
}

interface ChatProviderConfig {
  sessionId: string | null;
  setSessionId: Dispatch<SetStateAction<string | null>>;
  url: string;
  audioUrl: string;
  authHeader: string;
  threadId: string;
  historyVersion: number;
  onStreamComplete: () => void;
}

export function useChatProviderConfig(): ChatProviderConfig {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [historyVersion, setHistoryVersion] = useState(0);
  const { currentOrganizationId } = useOrganization();
  const pendingSessionId = useRef(crypto.randomUUID());

  const effectiveSessionId = sessionId ?? pendingSessionId.current;

  const handleSetSessionId: Dispatch<SetStateAction<string | null>> = (id) => {
    if (id === null) pendingSessionId.current = crypto.randomUUID();
    setSessionId(id);
  };

  const onStreamComplete = useCallback(() => {
    setHistoryVersion((v) => v + 1);
  }, []);

  const baseAiUrl = `${apiUrlOptions.fms}/v1/balance-ai`;
  const queryParams = `organizationId=${currentOrganizationId}&sessionId=${effectiveSessionId}`;

  return {
    sessionId,
    setSessionId: handleSetSessionId,
    url: `${baseAiUrl}/chat/ag-ui?${queryParams}`,
    audioUrl: `${baseAiUrl}/chat/ag-ui/audio?${queryParams}`,
    authHeader: buildAuthHeader(),
    threadId: effectiveSessionId,
    historyVersion,
    onStreamComplete,
  };
}
